import React, { useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter } from "@/components/ui/dialog";
import { UserPen, Loader2 } from "lucide-react";
import { toast } from "sonner";

export const EditProfileDialog = () => {
  const { user, refresh } = useAuth();
  const [open, setOpen] = useState(false);
  const [f, setF] = useState({ name: "", phone: "" });
  const [busy, setBusy] = useState(false);

  const onOpen = (v) => {
    if (v) setF({ name: user?.name || "", phone: user?.phone || "" });
    setOpen(v);
  };

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.patch("/admin/profile", f);
      await refresh();
      toast.success("تم تحديث الملف الشخصي");
      setOpen(false);
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
    setBusy(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpen}>
      <DialogTrigger asChild>
        <Button variant="outline" className="rounded-full gap-2" data-testid="edit-profile-btn"><UserPen className="w-4 h-4" /> الملف الشخصي</Button>
      </DialogTrigger>
      <DialogContent dir="rtl" data-testid="edit-profile-dialog">
        <DialogHeader><DialogTitle>تعديل الملف الشخصي</DialogTitle></DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          <div className="space-y-1.5"><Label>الاسم</Label>
            <Input value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} required minLength={2} maxLength={80} data-testid="profile-name-input" /></div>
          <div className="space-y-1.5"><Label>رقم الجوال</Label>
            <Input value={f.phone} onChange={(e) => setF({ ...f, phone: e.target.value })} required dir="ltr" inputMode="numeric" placeholder="05XXXXXXXX" data-testid="profile-phone-input" /></div>
          <div className="space-y-1.5"><Label>البريد الإلكتروني</Label>
            <Input value={user?.email || ""} disabled dir="ltr" data-testid="profile-email-display" /></div>
          <DialogFooter>
            <Button type="submit" disabled={busy} className="rounded-xl gap-2 w-full" data-testid="profile-save-btn">
              {busy && <Loader2 className="w-4 h-4 animate-spin" />} حفظ
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};
